<template>
  <div>
    <swiperBanner :adData="adData"></swiperBanner>
    <van-tabs v-model="active" @change="toggle" swipeable>
      <van-tab v-for="(item, index) in option" :title="item.title" :name="item.type" :key="index">
      </van-tab>
    </van-tabs>
    <van-form class="formstyle" ref="vanform" :submit-on-enter="false">
      <van-field
        readonly
        clickable
        name="picker"
        :value="ruleForm.name"
        label="一尘版块"
        right-icon="arrow"
        placeholder="点击选择一尘版块"
        @click="showPicker = true"
      />
      <van-field
        readonly
        clickable
        name="picker"
        :value="ruleForm.pushTypeName"
        label="提醒方式："
        right-icon="arrow"
        placeholder="点击选择提醒方式"
        @click="infosDialog = true"
      />
      <van-field
        v-model="ruleForm.content"
        name="content"
        :label="ruleForm.type == '1' ? '添加盯盘' : '添加一尘卖家会员'"
        :placeholder="ruleForm.type == '1' ? '如 冬奥钞' : '一尘会员（完整网名）'"
        :rules="[{ required: true, message: '请添加盯盘信息' }]"
      />

      <div
        v-if="userInfo && userInfo.vipExpireTime && userInfo.isVip == 1"
        style="margin: 16px;position: relative;"
      >
        <span style="display:block;font-size:12px;color:#969799;margin-bottom:5px;"
          >会员到期：{{ formatDateTimeRT(userInfo.vipExpireTime) }}</span
        >
        <van-button
          round
          block
          style="border-radius: 5px;
background: linear-gradient(0deg, #48C6EF 0%, #6F86D6 100%);color: #fff;"
          @click="onSubmit"
          native-type="button"
          >{{ isEdit ? '更新' : '添加' }}自动盯盘</van-button
        >
        <van-button class="posvipLoc" @click="backVip" size="mini" plain type="info"
          >会员续费</van-button
        >
      </div>
      <div v-else style="margin: 16px">
        <van-button
          style="border-radius: 5px;
background: linear-gradient(0deg, #48C6EF 0%, #6F86D6 100%);color: #fff;"
          @click="backVip"
          round
          block
          >开通会员,添加自动盯盘</van-button
        >
      </div>
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          value-key="name"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
    </van-form>
    <template v-if="false">
      <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa' }" content-position="left"
        >一尘新帖/成交贴盯盘信息说明：</van-divider
      >
      <div v-if="ruleForm.type == '1'" class="infos">
        1).盯盘助手会根据您添加的盯盘信息(某品种)，一旦有新帖发布，您会马上收到消息提醒。<br />
        2).盯盘助手会根据您添加的提醒信息，自动向您提醒此品种的最新成交帖。<br />
        3).每一条提醒信息仅限添加一个关键字，可详细描述，方便您精准定位找到。如:冬奥钞 捆 无47。<br />
        4).消息提醒太多，可详细描述关键字 如 冬奥钞 捆 无47，也可以点击“我的盯盘”，删除盯盘提醒。<br />
      </div>
      <div v-if="ruleForm.type == '2'" class="infos">
        1).盯盘助手会根据您添加的卖家会员信息，一旦有新帖发布，您会马上收到消息提醒。<br />
        2).卖家会员的发帖（无论求购或出售帖）,一旦有跟帖回复时，您会马上收到消息提醒，实时通知您成交信息。注：跟帖内容中只有包含“确认”字眼，才会收到消息提醒<br />
        3).每一条盯盘信息仅限添加一个卖家会员网名，方便您精准定位。<br />
        4).消息提醒太多，可以点击“我的盯盘”，取消消息提醒。<br />
      </div>
      <div class="van-hairline--top"></div>
      <div class="tips">
        注：一尘盯盘小助手提供实时的提醒服务，满足用户设置的条件时，会将信息推送到您手机上，该服务依赖移动互联网的信息传输，有可能出现信息的延迟送达，如果您不关注本公众号
        则无法收到通知提醒功能，本信息只供参考，不构成任何投资建议。投资有风险，只要不追高
        韭菜变镰刀。
      </div>
    </template>
    <!-- <div class="personal">
      <router-link to="/personal">我的<br />盯盘</router-link>
    </div> -->

    <div class="mydp">
      <div class="sline"></div>
      我的盯盘
    </div>
    <div class="sectiondp">
      <template v-if="list.length">
        <div v-for="(item, index) in list" :key="index" class="dRow">
          <div class="l">
            <img class="td" src="../../assets/img/tdIcon.png" alt="" />
            <div class="dRowinfos">
              <div class="title">{{ item.subscribeContent }}</div>
              <div class="desc">{{ pushTypeOption[item.pushType] }}</div>
            </div>
          </div>
          <div @click="del(item, index)" class="ricon">
            <img src="../../assets//img/reduceIcon.png" alt="" />
          </div>
        </div>
      </template>
      <div class="nocontent" v-else>
        <img src="../../assets/img/noContentIcon.png" alt="" />
        空空如也，快去添加您的盯盘吧！
      </div>
    </div>
    <van-dialog
      v-model="infosDialog"
      @confirm="(ruleForm.pushTypeName = pushTypeOption[ruleForm.pushType]), (infosDialog = false)"
      title="盯盘信息(品种名称)"
    >
      <van-cell title="名称：" :value="ruleForm.content" />

      <van-radio-group v-model="ruleForm.pushType">
        <van-cell-group>
          <van-cell title="全部提醒" clickable @click="ruleForm.pushType = 0">
            <template #right-icon>
              <van-radio :name="0" />
            </template>
          </van-cell>
          <van-cell title="只提醒求购帖" clickable @click="ruleForm.pushType = 1">
            <template #right-icon>
              <van-radio :name="1" />
            </template>
          </van-cell>
          <van-cell title="只提醒出售帖" clickable @click="ruleForm.pushType = 2">
            <template #right-icon>
              <van-radio :name="2" />
            </template>
          </van-cell>
          <van-cell title="只提醒成交帖" clickable @click="ruleForm.pushType = 3">
            <template #right-icon>
              <van-radio :name="3" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-dialog>
  </div>
</template>
<script>
import {
  getSectionList,
  saveSubscribe,
  updateSubscribeVo,
  getSubscribeInfo,
  rmSubsrcibeInfo,
} from '@/api/base';
import { formatDateTimeRT } from '@/utils/index';
import swiperBanner from '../components/swiper.vue';
export default {
  components: { swiperBanner },
  data() {
    return {
      columns: [],
      showPicker: false,
      infosDialog: false,
      isEdit: false,
      ruleForm: {
        name: '全部版块',
        type: '1',
        sectionCode: '',
        // openId:'oFQ7G5vJ1X0v-YHs4eROQUIAVNFU',
        content: '',
        pushType: 0,
        pushTypeName: '全部提醒',
      },
      option: [
        { type: '1', title: '一尘新帖盯盘' },
        { type: '2', title: '一尘卖家盯盘' },
      ],
      pushTypeOption: {
        0: '全部提醒',
        1: '只提醒求购帖',
        2: '只提醒出售帖',
        3: '只提醒成交帖',
      },
      active: '1',
      adData: this.$store.state.app.adBanner.smallList,
      list: [],
    };
  },
  computed: {
    userInfo() {
      console.log(this.$store.state.app.userinfos);
      return this.$store.state.app.userinfos;
    },
  },
  created() {
    console.log(this);
    this.ruleForm.type = this.$route.query.type || '1';
    this.isEdit = !!this.$route.query.isEdit;
    if (this.isEdit) {
      let obj = this.$route.query;
      this.ruleForm.content = obj.subscribeContent;
      this.ruleForm.type = obj.type;
      this.ruleForm.sectionCode = obj.sectionCode;
      this.ruleForm.pushType = Number(obj.pushType);
      this.ruleForm.id = obj.id;
      this.active = obj.type;
    }
    this.init();
    this.onLoad();
  },
  methods: {
    formatDateTimeRT,
    init() {
      let str = window.localStorage.getItem('plateList');
      if (JSON.parse(str) && JSON.parse(str).length > 1) {
        this.columns = JSON.parse(str);
        let that = this;
        this.columns = JSON.parse(str).sort((a, b) => a.sortno - b.sortno);
        this.columns.map(item => {
          // item.children.unshift({ name: '全部', code: null });
          item.children.sort((a, b) => a.sortno - b.sortno);
          item.children.map(it => {
            // if (it.code == that.$route.query.sectionCode) {
            //   this.ruleForm.name = [item.name, it.name];
            // }
          });
        });
        this.columns.unshift({
          name: '全部',
          code: null,
          children: [{ name: '全部', code: null }],
        });
      } else {
        getSectionList().then(res => {
          let that = this;
          this.columns = res.data.sort((a, b) => a.sortno - b.sortno);
          this.columns.map(item => {
            // item.children.unshift({ name: '全部', code: null });
            item.children.sort((a, b) => a.sortno - b.sortno);
            item.children.map(it => {
              if (it.code == that.$route.query.sectionCode) {
                this.ruleForm.name = [item.name, it.name];
              }
            });
          });
          this.columns.unshift({
            name: '全部',
            code: null,
            children: [{ name: '全部', code: null }],
          });
        });
      }
    },
    toggle() {
      this.ruleForm.type = this.active;
      this.onLoad();
    },
    onConfirm(value, e) {
      this.ruleForm.name = value.toString();
      if (value.indexOf('全部') != -1) {
        this.ruleForm.name = '全部版块';
      }
      this.ruleForm.sectionCode = this.columns[e[0]].children[e[1]].code;
      this.showPicker = false;
      console.log(this.ruleForm.sectionCode);
    },
    backVip() {
      this.$router.push({ path: '/vip', query: { item: new Date().getTime() } });
    },
    onSubmit() {
      let that = this;
      this.$refs.vanform.validate().then(res => {
        let fetch = this.isEdit ? updateSubscribeVo : saveSubscribe;
        fetch(this.ruleForm).then(res => {
          // this.$toast('添加成功,在“我的盯盘”查看');
          // this.ruleForm = {
          //   name: '',
          //   sectionCode: '',
          //   content: '',
          //   type: this.ruleForm.type,
          //   id: '',
          //   pushType: 0,
          // };
          if (that.isEdit) {
            this.$router.back();
            return;
          }
          this.$toast(`${that.isEdit ? '更新' : '添加'}成功`);
          // this.$dialog
          //   .alert({
          //     title: `${that.isEdit ? '更新' : '添加'}成功`,
          //     message: '请点击“我的菜单”查看',
          //   })
          //   .then(() => {
          //     // on close
          //     // this.$router.push({ path: '/user', replace: true });
          //   });
          this.onLoad();
        });
      });
    },

    onLoad() {
      getSubscribeInfo({ type: this.active }).then(res => {
        let tmpList = res.data || [];
        this.list = tmpList;
      });
    },
    del(item, index) {
      this.$dialog
        .confirm({
          title: '是否确认删除',
          message: '',
        })
        .then(() => {
          // on confirm
          rmSubsrcibeInfo(item.id).then(res => {
            this.list.splice(index, 1);
            this.$toast('删除成功');
          });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.infos {
  font-size: 16px;
  padding: 0 20px;
  line-height: 30px;
}
.tips {
  margin-top: 20px;
  padding: 0 20px;
  font-size: 14px;
  color: #ff976a;
}
.personal {
  position: fixed;
  bottom: 10%;
  right: 8%;
  z-index: 888;
  background: #ff9900;
  width: 70px;
  height: 70px;
  border-radius: 40px;
  box-shadow: 2px 2px 2px #888888;
  opacity: 0.7;
  /* padding-bottom: constant(safe-area-inset-bottom); */
  /* padding-bottom: env(safe-area-inset-bottom); */
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.posvipLoc {
  position: absolute;
  right: 0;
  top: -5px;
}
.formstyle {
  background: #ffffff;
  box-shadow: 0px 0px 25.5px #f2f5e9;
  padding-bottom: 18px;
  margin-bottom: 6px;
}
.mydp {
  background: #ffffff;
  box-shadow: 0px 0px 25.5px #f2f5e9;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
  padding: 8px 0;
  padding-left: 25px;
  .sline {
    width: 2.66px;
    height: 16px;
    opacity: 1;
    border-radius: 3px;
    background: linear-gradient(180deg, #fad0c4 0%, #fad0c4 0%, #2a82e4 0%);
    box-shadow: 0px 0px 25.5px #f2f5e9;
    margin-right: 4px;
  }
}

.sectiondp {
  background: rgba(255, 255, 255, 1);
  // box-shadow: 0px 0px 25.5px rgba(242, 245, 233, 1);
  padding: 0px 25px;
  .dRow {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(246, 247, 240, 1);
    padding-bottom: 5px;
    padding-top: 11px;
    .l {
      display: flex;
      .td {
        display: block;
        width: 18px;
        height: 18px;
        margin-right: 5px;
      }
      .dRowinfos {
        .title {
          font-size: 18px;
          font-weight: 400;
          letter-spacing: 0px;
          line-height: 17.84px;
          color: rgba(68, 71, 54, 1);
          margin-bottom: 8px;
        }
        .desc {
          font-size: 12px;
          font-weight: 400;
          letter-spacing: 0px;
          line-height: 12.35px;
          color: rgba(166, 166, 166, 1);
        }
      }
    }
    .ricon {
      display: flex;
      align-items: center;
      img {
        display: block;
        width: 18px;
        height: 18px;
      }
    }
  }
  .nocontent {
    display: flex;
    padding-top: 10px;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 21.95px;
    color: rgba(166, 166, 166, 1);
    img {
      display: flex;
      width: 64px;
      height: 64px;
      margin-right: 7px;
    }
  }
}
</style>
